











































































































































































































































































































































































































































































import { Component, Vue, Prop,Watch } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import { QuestionResponseData } from '../../models/jobs/questionnaireresponse';
import DatePicker from 'vuejs-datepicker';


import {
  SURVEY_DETAILS_SUCCESS_MESSAGE,
  SURVEY_QUESTION_CODE_TEXT,
  SURVEY_QUESTION_CODE_MULTIPLE_CHOICE,
  SURVEY_QUESTION_CODE_RADIO,
  SURVEY_QUESTION_CODE_RATING,
  SURVEY_FEEDBACK_QUESTION_CODE_TEXT,
  RATING_F_QUES_CONDITION_ID_EQUAL,
  RATING_F_QUES_CONDITION_ID_GREATER_THAN,
  RATING_F_QUES_CONDITION_ID_LESS_THAN,
  SURVEY_QUESTION_CODE_DROPDOWN,
  SURVEY_QUESTION_CODE_DATE
} from '../Survey/SurveyConstants';
import Multiselect from 'vue-multiselect';
import {
  QuestionnaireResponse,QuestionnaireDetailRequest,
  UserQuestionResponse
} from '../../models/jobs/questionnaireresponse';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

@Component({
  components: {Multiselect,DatePicker},
  
})
export default class QuestionnaireSection extends Vue {
  @Prop() questions;
  @Prop() isBranchedQuestionnaire;
  @Prop() questionTemplateId;
  private allMandatoryQuestionAnswered: boolean = true;
  private answeredQuestions_: any[] = [];
  private requiredQuestionCount = 0;
  private multiSelectValues: any[]=[];
  private singleSelectValue: any[]=[];
  private hasNextSetOfQuestion:boolean = false;
  private hasPreviousSetOfQuestion:boolean = false;
  private isQuestionnaireActionComplete = false;
  private branchedQuestionnierComplete = false;
  public userID : number = vxm.users.myUserProfile.userId;
  private dropdownSelectedValue: any[]=[];
  private branchedQuestions: any [] = [];
  private questionnaireRequired :boolean= false;
  private isResumeContinueBtn :boolean = false;
  private isSupportingContinueBtn :boolean= false;
  private isQuestionnaireContinueBtn :boolean = false;
  public enableNextDisableContinue : boolean = false;
  private questionnaireRequiredCount=0;
  private alphaRegex: RegExp = new RegExp(
    /^[a-zA-Z ]+$/,
  );
  private alphaNumericRegex: RegExp = new RegExp(
    /^[a-zA-Z0-9 ]*$/,
  );
  private hasAnsweredAllQuestions :boolean = false;

  $wlToastr: any;

  get companyCode() {
    return vxm.jobs.CompanyInfo.companyId;
  }

 get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat || '';
  }

  get enableNextBtn(){
    if(this.hasNextSetOfQuestion && this.branchedQuestionnierComplete){
      return true;
    }
    return false;
  } 

  firstSetBranchedQuestions(){
  let questionnaireDetailRequset :  QuestionnaireDetailRequest = new QuestionnaireDetailRequest();
  questionnaireDetailRequset.navigation = "";
  questionnaireDetailRequset.currentQuestionId = "";
  questionnaireDetailRequset.companyCode = this.companyCode;
  questionnaireDetailRequset.questionnaireInfo.userId = this.userID;
  questionnaireDetailRequset.questionnaireInfo.jobPostingId = this.$route.params.JobID;
  questionnaireDetailRequset.questionnaireInfo.questionResponseData = [];
  questionnaireDetailRequset.questionnaireInfo.referralCode= "";
  questionnaireDetailRequset.questionnaireInfo.questionTemplateId = this.questionTemplateId;
  this.$modal.show('survey-spinner');
  let respPromise1 = vxm.jobs.getBranchedQuestionaireListing(questionnaireDetailRequset);
  Promise.all([respPromise1]).then(
        (supportResp) => {
          this.$modal.hide('survey-spinner');
          // this.dropdownSelectedValue=[];
          this.processBranchedQuestionResponse(supportResp);
          // this.scrollToBodyPosition();
        },
        (err) => {
          console.log("errr"+err)
        },
      );


}
  mounted() {
    let requiredQuestionCount = 0;
    this.allMandatoryQuestionAnswered = true;
    this.answeredQuestions_ = [];
    let questionIndex = -1;
    if(!this.isBranchedQuestionnaire){
    this.questions.forEach((question) => {
      questionIndex = questionIndex + 1;
      if(question.questionType == '01' && question.userQuestionResponse.userAnswerList.length>0){
        let multiselect : any[]=[];
        for(var i=0; i<question.userQuestionResponse.userAnswerList.length;i++){
          for(var j=0; j<question.answerList.length;j++ ){
            if(question.userQuestionResponse.userAnswerList[i] == question.answerList[j].answerMasterID ){
               multiselect.push(question.answerList[j]);
            }
          }
       
        }
        this.multiSelectValues[questionIndex] = multiselect;
        console.log(" this.multiSelectValues inside if condition", this.multiSelectValues);
      }
      if((question.questionType == '03' || question.questionType == '12') && question.userQuestionResponse.userAnswerList){
          for(var j=0; j<question.answerList.length;j++ ){
            if(question.userQuestionResponse.userAnswerList == question.answerList[j].answerMasterID ){
           //   this.singleSelectValue.push(question.answerList[j])
              this.singleSelectValue[questionIndex] = question.answerList[j];
              // if(question.questionType == '03'){
              //   question.userQuestionResponse.userAnswerList= [[question.answerList[j].answerMasterID]]
              // }else{
                question.userQuestionResponse.userAnswerList= [question.answerList[j].answerMasterID]
             // }
            }
          } 
      }
      if(question.questionType == '06'){
        for(var j=0; j<question.answerList.length;j++ ){
            if(question.userQuestionResponse.userAnswerList == question.answerList[j].answerMasterID ){
                question.userQuestionResponse.userAnswerList= [question.answerList[j].answerMasterID] 
            }
        } 
      }
      let isQuestionAnswered = this.isQuestionAnswered(question);
      if (isQuestionAnswered) {
        this.answeredQuestions_.push(question);
      }

      if (question.questionRequired) {
        requiredQuestionCount++;
      }

      if (question.questionRequired && !isQuestionAnswered) {
        this.allMandatoryQuestionAnswered = false;
      }

      //feedback question

      if (question.feedbackQuestion) {
        isQuestionAnswered = this.isQuestionAnswered(question.feedbackQuestion);
        if (isQuestionAnswered) {
          this.answeredQuestions_.push(question.feedbackQuestion);
        }

        if (question.questionRequired && !isQuestionAnswered) {
          this.allMandatoryQuestionAnswered = false;
        }
        if (question.feedbackQuestion.questionRequired) {
          requiredQuestionCount++;
        }
      }
    });

    this.requiredQuestionCount = requiredQuestionCount;
    if(!this.isBranchedQuestionnaire){
    this.$emit('questionnaireanswered', {
      answeredQuestions: this.answeredQuestions_,
      allMandatoryQuestionAnswered: this.allMandatoryQuestionAnswered,
    });
  }
  }
  else{
      this.firstSetBranchedQuestions()
  }
  }

  updateSelectedValues(question, value) {
    console.log("calling updateSelectedValues")
  if((question.questionType === '03') || (question.questionType === '12')){
      if(value && value.answerMasterID ){
        question.userQuestionResponse
      question.userQuestionResponse.userAnswerList=  [value.answerMasterID];
      }
      else{
        question.userQuestionResponse.userAnswerList = [];
      }
  }else{
    if ( Array.isArray(value)) {
      question.userQuestionResponse.userAnswerList = value.map(
        (option) => option.answerMasterID,
      );
    } else {
      if (
        question.userQuestionResponse.userAnswerList.length == 0 ||
        (value &&
          !question.userQuestionResponse.userAnswerList.includes(
            value.answerMasterID,
          ))
      ) {
        question.userQuestionResponse.userAnswerList =
          value && value.answerMasterID;
      } else {
        question.userQuestionResponse.userAnswerList = [];
      }
    }

  }
  this.enableSurveySubmitBtn(question);

  if(this.isBranchedQuestionnaire){
        if( !question.alreadyanswered && question.questionRequired && question.userQuestionResponse.userAnswerList){

          this.questionnaireRequiredCount-=1
          question.alreadyanswered=true
          if(this.questionnaireRequiredCount == 0){
            this.branchedQuestionnierComplete = true
            this.isQuestionnaireActionComplete = true
          }
        }
        else{
          if( question.questionRequired && question.alreadyanswered && (question.userQuestionResponse.userAnswerList.length==0 || !question.userQuestionResponse.userAnswerList)){
            this.questionnaireRequiredCount+=1
            question.alreadyanswered=false
            this.branchedQuestionnierComplete = false
          this.isQuestionnaireActionComplete = false

          }


        }

  }
  }

  onInput(question) {
    if (this.$refs['question_span2' + question.questionID]) {
      this.$refs['question_span2' + question.questionID][0].textContent =
        '(' +
        question.userQuestionResponse.questionTextResponse.length +
        '/' +
        question.maxLength +
        ')';
    }

    if (
      question.status &&
      question.status === '0' &&
      question.userQuestionResponse.questionTextResponse &&
      question.userQuestionResponse.questionTextResponse.length > 1
    ) {
      question.status = '1';
    } else if (
      question.status &&
      question.status === '1' &&
      question.userQuestionResponse.questionTextResponse &&
      question.userQuestionResponse.questionTextResponse.length === 0
    ) {
      question.status = '0';
    }

    if(this.isBranchedQuestionnaire &&  question.questionRequired  && question.questionType=='13' && !question.alreadyanswered){
      this.questionnaireRequiredCount-=1;
      question.alreadyanswered=true
      if(this.questionnaireRequiredCount == 0){
          this.branchedQuestionnierComplete = true
          this.isQuestionnaireActionComplete = true
        }


    }
    
    if(this.isBranchedQuestionnaire && question.questionRequired  && ( question.questionType === '04' ||
                      question.questionType === '11' ||
                      question.questionType === '02')){
let isTextValidated = this.validateTextResponse(question);
if(isTextValidated && question.userQuestionResponse.questionTextResponse && !question.alreadyanswered){
  
  this.questionnaireRequiredCount-=1;
  question.alreadyanswered=true
  if(this.questionnaireRequiredCount == 0){
          this.branchedQuestionnierComplete = true
          this.isQuestionnaireActionComplete = true
        }
}
else if(!isTextValidated && question.alreadyanswered){
  this.questionnaireRequiredCount+=1;
  question.alreadyanswered=false
          this.branchedQuestionnierComplete = false
          this.isQuestionnaireActionComplete = false
}
else if(!isTextValidated &&  !question.alreadyanswered){
          this.branchedQuestionnierComplete = false
          this.isQuestionnaireActionComplete = false

}
else if(isTextValidated && (question.alreadyanswered && question.userQuestionResponse.questionTextResponse.length==0)){
  this.questionnaireRequiredCount+=1;
  question.alreadyanswered=false
          this.branchedQuestionnierComplete = false
          this.isQuestionnaireActionComplete = false
}
    }
    this.enableSurveySubmitBtn(question);
  }

  get QuestionnaireData_(): any {
    
  this.answeredQuestions_ = [];

  this.questions.forEach((question) => {
    if (question.questionType === SURVEY_QUESTION_CODE_RATING) {
      question.userQuestionResponse &&
        this.showRatingTypeFeedbackQuestion(question, true);
      if (
        question.userQuestionResponse &&
        Array.isArray(question.userQuestionResponse.userAnswerList) &&
        question.userQuestionResponse.userAnswerList.length > 0
      ) {
        const answerId = question.userQuestionResponse.userAnswerList[0];
        question.answerIndex = question.answerList.findIndex(
          (a) => a.answerMasterID === answerId
        );
      } else {
        question.answerIndex = -1;
      }
    }
    if (!question.userQuestionResponse) {
      if (
        question.questionType === '04' ||
        question.questionType === '02' ||
        question.questionType === '11'
      ) {
        question.userQuestionResponse = { questionTextResponse: '' };
      } else {
        question.userQuestionResponse = {
          questionTextResponse: '',
          userAnswerList: [],
        };
      }
    }
    if (this.isQuestionAnswered(question)) {
      this.answeredQuestions_.push(question);
    }
    if (question.feedbackQuestion) {
      if (!question.feedbackQuestion.userQuestionResponse) {
        question.feedbackQuestion.userQuestionResponse = { questionTextResponse: '' };
      }

      question.showFeedbackQuestion =
        !!question.feedbackQuestion.userQuestionResponse.questionTextResponse;

      question.feedbackQuestion.status = question.showFeedbackQuestion ? '1' : '0';

      if (this.isQuestionAnswered(question.feedbackQuestion)) {
        this.answeredQuestions_.push(question.feedbackQuestion);
      }
    }
  });
  return this.questions;
}

  validateTextResponse(question){
  if(question.minLength !=null && question.maxLength!=null){
if(question.userQuestionResponse.questionTextResponse.length>=question.minLength && question.userQuestionResponse.questionTextResponse.length<=question.maxLength)
return true  
} 
else if(question.minLength ==null && question.maxLength!=null){
 if( question.userQuestionResponse.questionTextResponse.length<=question.maxLength){
return true
 }
}
else if(question.minLength !=null && question.maxLength==null){
 if( question.userQuestionResponse.questionTextResponse.length>=question.minLength){
return true
 }
}

else if(question.minLength ==null && question.maxLength==null ) {
  return true
}
return false
  }
  
  getNextQuestionandSave(){
    if(!this.isQuestionnaireActionComplete){
      return;
    }
    this.getBranchedQuestionerData('next');
}

  getPreviousQuestion(){
    this.getBranchedQuestionerData('previous');
  }
  prepareBranchedQuestionnaireRequestPayload(): any{
    let questionResponseData: QuestionResponseData[] = [];
    this.branchedQuestions.forEach((question) => {
      let obj = {
        questionID: question.questionID,
        userQuestionResponse: question.userQuestionResponse,
      };
      if (
        (question.questionType === SURVEY_QUESTION_CODE_RATING ||
          question.questionType === SURVEY_QUESTION_CODE_RADIO ||
          question.questionType === SURVEY_QUESTION_CODE_DROPDOWN ||
          question.questionType === SURVEY_QUESTION_CODE_MULTIPLE_CHOICE  ) &&
        !Array.isArray(obj.userQuestionResponse.userAnswerList)
      ) {
        obj.userQuestionResponse.userAnswerList = [
          obj.userQuestionResponse.userAnswerList,
        ];
      }

      if (question.status && question.status === '0') {
        obj.userQuestionResponse.questionTextResponse = null;
      }
      questionResponseData.push(obj);
    });
    return questionResponseData;
    
  }
  async getBranchedQuestionerData(navigation?) {
  let questionnaireDetailRequset :  QuestionnaireDetailRequest = new QuestionnaireDetailRequest();
  questionnaireDetailRequset.navigation = "";
  questionnaireDetailRequset.currentQuestionId = "";
  questionnaireDetailRequset.companyCode = this.companyCode;
  questionnaireDetailRequset.questionnaireInfo.userId = this.userID;
  questionnaireDetailRequset.questionnaireInfo.jobPostingId = this.$route.params.JobID;
  questionnaireDetailRequset.questionnaireInfo.questionResponseData = [];
  questionnaireDetailRequset.questionnaireInfo.referralCode= "";
  questionnaireDetailRequset.questionnaireInfo.questionTemplateId = this.questionTemplateId;
  if(!this.hasNextSetOfQuestion){
    questionnaireDetailRequset.hasAnsweredAll = true;
    this.hasAnsweredAllQuestions = true;
  }
  if(navigation === "next"  || navigation === 'continue') {
    questionnaireDetailRequset.navigation = "next";
    questionnaireDetailRequset.currentQuestionId = this.branchedQuestions[this.branchedQuestions.length -1].questionID;
    questionnaireDetailRequset.questionnaireInfo.questionResponseData = this.prepareBranchedQuestionnaireRequestPayload();
  }
  if(navigation === "previous") {
    questionnaireDetailRequset.navigation = navigation;
    questionnaireDetailRequset.currentQuestionId = this.branchedQuestions[0].questionID;
    questionnaireDetailRequset.questionnaireInfo.questionResponseData = this.prepareBranchedQuestionnaireRequestPayload();
  }
  this.$modal.show('survey-spinner');
  let respPromise1 = vxm.jobs.getBranchedQuestionaireListing(questionnaireDetailRequset);
  Promise.all([respPromise1]).then(
        (supportResp) => {
          if(supportResp && supportResp[0].questions && supportResp[0].questions.length === 0 && 
               supportResp[0].hasNextQuestion === false &&  navigation === 'next'
          ){
            this.$wlToastr(
            'error',
            'You\'ve reached the end of questionnaire. Please click "Continue" to proceed.',
            'Job Application',
             );
             this.isQuestionnaireActionComplete = true;
             this.hasNextSetOfQuestion = false;
             this.enableNextDisableContinue = true;
             return;
          }
          this.$modal.hide('survey-spinner');
          this.dropdownSelectedValue=[];
          this.processBranchedQuestionResponse(supportResp);
        },
        (err) => {
          this.$wlToastr('error', 'Error fetching Questionnaire', this.$t('job-apply-text'));
        },
      );      
  }

  placeHolderContent(question){
    if(question.questionRequired && question.questionType === '13'){
      return 'please select date *';
    }
    else if(!question.questionRequired && question.questionType === '13'){
      return 'please select date';
    }
    else if(question.questionRequired){
      return 'please select values *';
    }
    else{
    return 'please select values';
    }
  }

 get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  processBranchedQuestionResponse(response){
    this.hasNextSetOfQuestion =  response[0].hasNextQuestion;
    this.hasPreviousSetOfQuestion =  response[0].hasPreviousQuestion;
    let questionRequiredCount = 0;
    let answeredQuestionCount = 0;
    let mandatoryansweredCount =0;
    //let isTextMappedValue = false;
    if (response && response[0].questions && response[0].questions.length > 0) {
        this.isQuestionnaireActionComplete = true;
        this.branchedQuestionnierComplete = true;
        let questionIndex = -1;
        // let userAnswerList : any[] = [];
        response[0].questions.forEach((question) => {
          questionIndex = questionIndex + 1;
          let userAnswerList : any[] = [];
          let isTextMappedValue = false;
        if(question.questionRequired){
          questionRequiredCount = questionRequiredCount+1;
        }
        if(!question.questionRequired){
            this.branchedQuestionnierComplete = true;
        }
        if (question.questionRequired && !question.userQuestionResponse) {
          answeredQuestionCount = answeredQuestionCount+1;
          this.isQuestionnaireActionComplete = false;
          this.branchedQuestionnierComplete = false;
        }
        else if(question.questionRequired && question.userQuestionResponse){
          question.alreadyanswered = true

        }
        if(!question.userQuestionResponse && (question.mappedAttributeValue || question.mappedAttributeValues)){
           if(question.mappedAttributeValue && !question.mappedAttributeValues){
              if(isNaN(Number(question.mappedAttributeValue))){
                  isTextMappedValue = true;
              }
            }
          if(question.mappedAttributeValue && !question.answerList && (question.questionType === SURVEY_QUESTION_CODE_DATE
            || question.questionType === SURVEY_QUESTION_CODE_TEXT )){
              if(question.questionRequired){
                answeredQuestionCount=answeredQuestionCount-1
                question.alreadyanswered = true
              }
                 question.userQuestionResponse = {
                  questionTextResponse: question.mappedAttributeValue
              };
          }
          else if(question.mappedAttributeValue && isTextMappedValue && (question.questionType === SURVEY_QUESTION_CODE_DATE
            || question.questionType === SURVEY_QUESTION_CODE_TEXT )){
              if(question.questionRequired){
                answeredQuestionCount=answeredQuestionCount-1
                question.alreadyanswered = true
              }
              question.userQuestionResponse = {
                  questionTextResponse: question.mappedAttributeValue
              };
          }
          else if(question.mappedAttributeValue && isTextMappedValue && (question.questionType === SURVEY_QUESTION_CODE_RADIO
           || question.questionType === SURVEY_QUESTION_CODE_RATING|| question.questionType === SURVEY_QUESTION_CODE_DROPDOWN)){
            for(var j=0; j<question.answerList.length;j++ ){
              if(question.mappedAttributeValue == question.answerList[j].answerValue ){
                if(question.questionRequired){
                  answeredQuestionCount=answeredQuestionCount-1
                  question.alreadyanswered = true
                }
                      userAnswerList.push(question.answerList[j].answerMasterID)
                      question.userQuestionResponse = {
                      userAnswerList: userAnswerList || [] 
              };
              }
              else{
                  if(userAnswerList.length === 0){
                     question.userQuestionResponse = null;
                  }
              }  
            }
          }
          else if(question.mappedAttributeValue && !isTextMappedValue && (question.questionType === SURVEY_QUESTION_CODE_RADIO || 
          question.questionType === SURVEY_QUESTION_CODE_RATING || question.questionType === SURVEY_QUESTION_CODE_DROPDOWN)){
              for(var j=0; j<question.answerList.length;j++ ){
                if(question.answerList[j].targetFieldValue){
                  if(question.mappedAttributeValue == question.answerList[j].targetFieldValue){
                    if(question.questionRequired){
                      answeredQuestionCount=answeredQuestionCount-1
                      question.alreadyanswered = true
                  }
                    userAnswerList.push(question.answerList[j].answerMasterID);
                          question.userQuestionResponse = {
                      userAnswerList: userAnswerList || [],
                    };  
                  }
                  else{
                        if(userAnswerList.length === 0){
                          question.userQuestionResponse = null;
                        }
                  }
                }
                else{
                  if(question.mappedAttributeValue == question.answerList[j].answerValue){
                    if(question.questionRequired){
                      answeredQuestionCount=answeredQuestionCount-1
                      question.alreadyanswered = true
                    }
                    userAnswerList.push(question.answerList[j].answerMasterID);
                    question.userQuestionResponse = {
                      userAnswerList: userAnswerList || [],
                    };  
                  }
                  else{
                    if(userAnswerList.length === 0){
                       question.userQuestionResponse = null;
                    }
                  }
              }
           }
          } 
          else if(question.mappedAttributeValues && question.questionType === SURVEY_QUESTION_CODE_MULTIPLE_CHOICE){
               for(var i=0; i<question.mappedAttributeValues.length;i++){
               for(var j=0; j<question.answerList.length;j++ ){
                if(question.mappedAttributeValues[i] == question.answerList[j].targetFieldValue ){
                  if(question.questionRequired){
                    answeredQuestionCount=answeredQuestionCount-1
                    question.alreadyanswered = true

              }
                 userAnswerList.push(question.answerList[j].answerMasterID);
              }
            }
           }
               question.userQuestionResponse = {
                userAnswerList: userAnswerList || [],
              };               
         }
        }
        if (
          question.userQuestionResponse &&
          question.userQuestionResponse.userAnswerList &&
          (question.questionType === SURVEY_QUESTION_CODE_RADIO ||
            question.questionType === SURVEY_QUESTION_CODE_RATING || 
            question.questionType === SURVEY_QUESTION_CODE_DROPDOWN)
        ) {
          question.userQuestionResponse.userAnswerList =
            question.userQuestionResponse.userAnswerList[0];
            if (
          question.questionType === SURVEY_QUESTION_CODE_RATING &&
          question.userQuestionResponse &&
          question.userQuestionResponse.userAnswerList
        ) {
          let answerId = question.userQuestionResponse.userAnswerList;
          let ind = question.answerList.findIndex(
            (answer) => answer.answerMasterID === answerId,
          );

          question.answerIndex = ind;
        }
        }
        if (!question.userQuestionResponse) {
          question.userQuestionResponse = {
            userAnswerList: [],
            questionTextResponse: '',
          };
        }

        if(question.questionType == '01' && question.userQuestionResponse.userAnswerList.length>0){
          let multiList : any[]=[];
          for(var i=0; i<question.userQuestionResponse.userAnswerList.length;i++){
          for(var j=0; j<question.answerList.length;j++ ){
            if(question.userQuestionResponse.userAnswerList[i] == question.answerList[j].answerMasterID ){
                multiList.push(question.answerList[j]);
            }
          }
          } 
          this.dropdownSelectedValue[questionIndex] = multiList;
        }
        if((question.questionType == '03' || question.questionType == '12' ) && question.userQuestionResponse.userAnswerList){
            for(var j=0; j<question.answerList.length;j++ ){
              if(question.userQuestionResponse.userAnswerList == question.answerList[j].answerMasterID ){
                this.dropdownSelectedValue[questionIndex] = question.answerList[j];
              }
            }
        }
      });
      if(!this.isQuestionnaireActionComplete){
      this.questionnaireRequiredCount= answeredQuestionCount;
      }
      if(answeredQuestionCount > 0){
           this.isQuestionnaireActionComplete = false;
           this.branchedQuestionnierComplete = false;
      }
      else{
        this.isQuestionnaireActionComplete = true;
           this.branchedQuestionnierComplete = true;
      }
      this.branchedQuestions = response[0].questions;
      this.questionnaireRequired = true;
      this.isResumeContinueBtn = false;
      this.isSupportingContinueBtn = false;
      this.isQuestionnaireContinueBtn = true;
      return;
    }
    this.questionnaireRequired = false;
  }
  getRatingStickWidth(size) {
  return { width: `calc(100% / ${size})`};

  }

  enableSurveySubmitBtn(question) {
    let index = this.isQuestionPresentInArr(question);
    if (index >= 0) {
      this.answeredQuestions_[index] = question;
    } else {
      this.answeredQuestions_.push(question);
    }
    let showFeedbackQuestion = this.showFeedbackQuestion(question);
    if (
      question.feedbackQuestion &&
      showFeedbackQuestion &&
      question.feedbackQuestion.userQuestionResponse &&
      question.feedbackQuestion.userQuestionResponse.questionTextResponse
    ) {
      question.feedbackQuestion.status = '1';
    } else if (question.feedbackQuestion && !showFeedbackQuestion) {
      question.feedbackQuestion.status = '0';
    }
    let size = this.answeredQuestions_.filter(
      (item) => item.questionRequired && this.isQuestionAnswered(item),
    ).length;
    this.allMandatoryQuestionAnswered = this.requiredQuestionCount === size;
    if(!this.isBranchedQuestionnaire){
    this.$emit('questionnaireanswered', {
      answeredQuestions: this.lodash.cloneDeep(this.answeredQuestions_),
      allMandatoryQuestionAnswered: this.allMandatoryQuestionAnswered,
    });
  }
  }

  isQuestionAnswered(question) {
    if (
      !(
        question.userQuestionResponse &&
        (question.userQuestionResponse.questionTextResponse ||
          (Array.isArray(question.userQuestionResponse.userAnswerList)
            ? question.userQuestionResponse.userAnswerList.length > 0
            : question.userQuestionResponse.userAnswerList))
      )
    ) {
      return false;
    } else {
      return true;
    }
  }
  textValidate(event, question) {
    event = event ? event : window.event;
    if(question.userQuestionResponse.questionTextResponse.length > 254 ||
      (event.clipboardData && event.clipboardData.getData('text').length > 254)){
      event.preventDefault();
    }

    if(question.validation && question.validation.typeInfo && question.validation.typeInfo.length){
       question.minLength = question.validation.typeInfo.length.min || question.minLength ;
       question.maxLength = question.validation.typeInfo.length.max || question.maxLength;
    }

    if((question.validation && question.validation.type) || question.answerTypeValue){
      const val = event.key || event.clipboardData && event.clipboardData.getData('text');
      switch((question.validation && question.validation.type) || question.answerTypeValue){
        case 'NUMERIC':
        case '01':
          if(isNaN(Number(val))){
            event.preventDefault();
          }
          break;
        case 'ALPHA':
        case '02':
          if(!this.alphaRegex.test(val)){
            event.preventDefault();
          }
          break;
        case 'ALPHANUMERIC':
        case '03':
          if(!this.alphaNumericRegex.test(val)){
            event.preventDefault();
          }
          break;
        default:
          break;
      }
    }
    return true;
  }

  // btnDisbled: !(
  //   isQuestionnaireActionComplete && isQuestionnaireContinueBtn && !this.hasNextSetOfQuestion

  @Watch('isQuestionnaireActionComplete')
  onUpdateQuestionnaireActionComplete() {
    if(this.isBranchedQuestionnaire){
    this.$emit('questionnaireanswered', {
      
      answeredQuestions: this.prepareBranchedQuestionnaireRequestPayload(),
      allMandatoryQuestionAnswered: ( this.isQuestionnaireActionComplete  && !this.hasNextSetOfQuestion),
      branchedQuestionnaireId:this.branchedQuestions[this.branchedQuestions.length -1].questionID,
      hasAnsweredAllQuestions: this.hasAnsweredAllQuestions
    });
  }
  }

  @Watch('hasNextSetOfQuestion')
  onLastBranchQuestions() {
    if(this.isBranchedQuestionnaire){

    this.$emit('questionnaireanswered', {
      
      answeredQuestions: this.prepareBranchedQuestionnaireRequestPayload(),
      allMandatoryQuestionAnswered: ( this.isQuestionnaireActionComplete  && !this.hasNextSetOfQuestion),
      branchedQuestionnaireId:this.branchedQuestions[this.branchedQuestions.length -1].questionID,
      hasAnsweredAllQuestions: this.hasAnsweredAllQuestions
    });
  }
  }
  highlightLeftRating(question, index, answerMasterID) {

    if(this.isBranchedQuestionnaire  && question.questionRequired  && !question.userQuestionResponse.alreadyanswered){

      this.questionnaireRequiredCount-=1
      question.userQuestionResponse.alreadyanswered = true
      if(this.questionnaireRequiredCount == 0){
          this.branchedQuestionnierComplete = true
          this.isQuestionnaireActionComplete = true
        }
}
    let arr: any = this.$refs['rating_' + question.questionID];
    let size = arr.length;
    for (let i = 0; i < size; i++) {
      arr[i].style['background-color'] = 'transparent';
    }
    arr[index].style['background-color'] = '#3D91F2';
    if (question.userQuestionResponse && question.userQuestionResponse) {
      if(!this.isBranchedQuestionnaire){
      question.userQuestionResponse.userAnswerList = answerMasterID;
      }
      else{
        question.userQuestionResponse.userAnswerList.push(answerMasterID);

      }
    }
 
    this.enableSurveySubmitBtn(question);
  }

  showMultipleChoiceFeedbackQuestion(question): boolean {
    let feedbackQuestionConditionValue =
      question.feedbackQuestion.feedbackQuestionConditionValue;
    let userQuestionResponse = question.userQuestionResponse.userAnswerList;
    let userQuestionResponseValue = {};
    for (let value of question.answerList) {
      if (
        userQuestionResponse.find(
          (selectedValue) => selectedValue === value.answerMasterID,
        )
      ) {
        userQuestionResponseValue[value.answerValue] = value.answerValue;
      }
    }
    for (let value of feedbackQuestionConditionValue) {
      if (userQuestionResponseValue.hasOwnProperty(value)) {
        question.showFeedbackQuestion = true;
        return true;
      }
    }
    question.showFeedbackQuestion = false;
    return false;
  }

  showRadioTypeFeedbackQuestion(question) {
    let userQuestionResponse = question.userQuestionResponse.userAnswerList;
    let feedbackQuestionConditionValue =
      question.feedbackQuestion.feedbackQuestionConditionValue[0];
    for (let value of question.answerList) {
      if (
        value.answerMasterID === userQuestionResponse &&
        value.answerValue === feedbackQuestionConditionValue
      ) {
        question.showFeedbackQuestion = true;
        return true;
      }
    }
    question.showFeedbackQuestion = false;
    return false;
  }

  showRatingTypeFeedbackQuestion(question, relaxDomCheck = false) {
    question.showFeedbackQuestion = false;
    let userResponse = Array.isArray(
      question.userQuestionResponse.userAnswerList,
    )
      ? question.userQuestionResponse.userAnswerList[0]
      : question.userQuestionResponse.userAnswerList;
    for (let value of question.answerList || []) {
      if (value.answerMasterID === userResponse) {
        for (let feedbackQuestion of question.feedbackQuestionList || []) {
          if (!feedbackQuestion.userQuestionResponse) {
            feedbackQuestion.userQuestionResponse = {
              questionTextResponse: '',
            };
          }
          if (question.showFeedbackQuestion) {
            break;
          }
          switch (feedbackQuestion.feedbackQuestionConditionID[0]) {
            case RATING_F_QUES_CONDITION_ID_LESS_THAN:
              if (
                value.answerRating <
                  Number(feedbackQuestion.feedbackQuestionConditionValue[0]) &&
                (this.$refs['feedback_question_' + question.questionID] ||
                  relaxDomCheck)
              ) {
                question.feedbackQuestion = feedbackQuestion;
                question.showFeedbackQuestion = true;
                return true;
              }
              break;
            case RATING_F_QUES_CONDITION_ID_GREATER_THAN:
              if (
                value.answerRating >
                  Number(feedbackQuestion.feedbackQuestionConditionValue[0]) &&
                (this.$refs['feedback_question_' + question.questionID] ||
                  relaxDomCheck)
              ) {
                question.showFeedbackQuestion = true;
                question.feedbackQuestion = feedbackQuestion;
                return true;
              }
              break;
            case RATING_F_QUES_CONDITION_ID_EQUAL:
              if (
                value.answerRating ===
                  Number(feedbackQuestion.feedbackQuestionConditionValue[0]) &&
                (this.$refs['feedback_question_' + question.questionID] ||
                  relaxDomCheck)
              ) {
                question.showFeedbackQuestion = true;
                question.feedbackQuestion = feedbackQuestion;
                return true;
              }
              break;
          }
        }
      }
    }
    if (this.$refs['feedback_question_' + question.questionID]) {
      question.showFeedbackQuestion = false;
    }
    return false;
  }

  showFeedbackQuestion(question): boolean {
    if (question.feedbackQuestion) {
      if (
        question.questionType === SURVEY_QUESTION_CODE_MULTIPLE_CHOICE ||
        question.questionType === '11'
      ) {
        return this.showMultipleChoiceFeedbackQuestion(question);
      } else if (question.questionType === SURVEY_QUESTION_CODE_RADIO) {
        return this.showRadioTypeFeedbackQuestion(question);
      } else if (question.questionType === SURVEY_QUESTION_CODE_RATING) {
        return this.showRatingTypeFeedbackQuestion(question);
      } else {
        return false;
      }
    }
    return false;
  }

  isQuestionPresentInArr(question) {
    return this.answeredQuestions_.findIndex(
      (k) => k.questionID === question.questionID,
    );
  }
}
